/**
 * API Configuration for PHP Backend
 * Uses REACT_APP_API_URL if set, otherwise localhost in dev, production in prod.
 * To use production API without XAMPP: set REACT_APP_API_URL=https://fracaso.in/api in frontend/.env.local
 */

const isDev = process.env.NODE_ENV === 'development';

const API_BASE_URL = process.env.REACT_APP_API_URL
  || (isDev ? 'http://localhost/api' : 'https://fracaso.in/api');

console.log("📡 API Configuration: API_BASE_URL=", API_BASE_URL);
console.log("🔗 Database: Hostinger Remote (srv1726.hstgr.io)");

export default API_BASE_URL;
